export default "__VITE_ASSET__B_w1u4Ch__"